<template>
  <div class="answers-container">
    <div ref="answersWrapper" class="answers-wrapper" :style=gridStyle>
      <answer
              ref="answer"
              v-for="answer in answers"
              :key="answer.answerId"
              v-bind="{
            answers,
            question,
            stats,
            poll,
            answer: answer,
            index: realAnswerIndex(answer),
            answerHeight
          }"
              :style="{ fontFamily: poll.jsStyle.answerFont.name }"
      />
    </div>
  </div>
</template>

<script>
import { findIndex } from 'ramda';
import CommonMixin from '../mixins/common.js';
import Answer from './Answer.vue';
const ANSWERS_IN_COLUMN = 8;

export default {
  name: 'answers',
  components: {
    Answer
  },
  data() {
    return {
      numberOfColumns: Math.ceil(this.answers.length / ANSWERS_IN_COLUMN) ,
      answerHeight: 50
    };
  },
  props: {
    ...CommonMixin.props,
    headerHeight: Number
  },
  computed: {
    ...CommonMixin.computed,
    gridStyle() {
      return {
        gridTemplateColumns: `repeat(${this.numberOfColumns}, 1fr)`,
        gridTemplateRows: `repeat(${Math.min(ANSWERS_IN_COLUMN, this.answers.length)}, 1fr)`,
        // height: this.getAvailableAnswersSpace() + 'px'
      }
    }
  },
  methods: {
    realAnswerIndex(answer) {
      return findIndex(a => a.answerId === answer.answerId)(this.answers);
    },

    getAvailableAnswersSpace() {
      return (
        Math.max(document.documentElement.clientHeight, window.innerHeight || 0) - this.headerHeight - 60
      );
    }
  },
  mounted() {
    this.answerHeight = Math.round((this.getAvailableAnswersSpace() - 40) / ANSWERS_IN_COLUMN);
  }
};
</script>

<style lang="scss" scoped>
.slideshow-enter {
  // 30px is the answer margin (15px top + bottom)
  transform: translateY(calc(100% + 30px));
}

.slideshow-leave-to {
  transform: translateY(calc(-100% - 30px));
}

.slideshow-leave-active {
  position: absolute;
}

.slideshow-move {
  transition: transform 1s;
}

.answers-container {
  overflow: hidden;
}

.answers-wrapper {
  margin: 15px;
  display: grid;
  grid-auto-flow: column;
  grid-gap: 10px;
}

.answers {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  position: relative;
  padding: 14px 0;
}
</style>
